var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nebIcon",class:[ _vm.name ],attrs:{"height":_vm.height,"width":_vm.width}},[_c(_vm.iconComponent,_vm._b({tag:"component",attrs:{"height":_vm.height,"width":_vm.width}},'component',_vm.options,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }